import { Box, CircularProgress, Typography, Chip } from '@mui/material';
import * as AppPics from 'assets/images';
import UserSelect from 'components/molecules/UserSelect';
import useDashboard from 'hooks/API/GET/useDashboard';
import React from 'react';
import { useParams, Link, useHistory } from 'react-router-dom';
import { ROLES } from 'utilities/constants';
import MoreFilters from './MoreFilters';
import { AuthContext } from 'context/AuthContext';
import { FetchContext } from 'context/FetchContext';

function IndividualReviewItem(props) {
  const { reviewItem } = useParams();
  const history = useHistory();
  const __pageConfig = __config[reviewItem];

  const [userObj, setUserObj] = React.useState({});
  const [contentOwner, setContentOwner] = React.useState(null);
  const [moreFilters, setMoreFilters] = React.useState({ isOpen: false });
  const [searchFilters, setSearchFilters] = React.useState({ forApi: {}, forLabels: [] });

  const { isLoading, isError, data } = useDashboard({
    enabled: !!reviewItem,
    userId: contentOwner?._id,
    configs: {
      params: {
        getItemsOf: reviewItem,
        ...(userObj?._id
          ? { type: 'user', userId: userObj?._id }
          : Object.keys(searchFilters.forApi).length > 0
          ? { type: 'curriculum', ...searchFilters.forApi }
          : {}),
      },
    },
  });
  const dataArray = data?.data || {};

  return (
    <>
      {moreFilters.isOpen && (
        <MoreFilters
          isOpen={moreFilters.isOpen}
          closeModal={() => {
            setMoreFilters({ isOpen: false });
          }}
          handleSearch={(apiFilters, apiBodyIds) => {
            setSearchFilters({ forApi: apiBodyIds, forLabels: apiFilters });
            setContentOwner(null);
          }}
        />
      )}
      <div className="mainWraper">
        <div className="tab app-l-tab_main">
          <ul className="tab__menu">
            <li className="back">
              <button className="btn-back" onClick={() => history.goBack()}>
                <img src={AppPics.BackSvg} alt="Back" />
              </button>
            </li>
          </ul>
          <div className="tab__content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-6">
                  <h2 className="prime-head p-0 boldtitle">Action Centre</h2>
                </div>
              </div>

              {searchFilters.forLabels.length > 0 ? (
                <section className="my-2">
                  {searchFilters.forLabels
                    .concat({
                      _id: Math.random(),
                      name: 'Clear filter',
                      chipProps: {
                        clickable: true,
                        onClick: () => {
                          setSearchFilters({ forApi: {}, forLabels: [] });
                          setContentOwner(null);
                        },
                      },
                    })
                    .map((item) => {
                      return (
                        <Chip
                          key={item._id}
                          label={item.name}
                          className="m-2"
                          {...(item?.chipProps ?? {})}
                        />
                      );
                    })}
                </section>
              ) : null}

              {isLoading ? (
                <div className="row justify-content-center">
                  <CircularProgress />
                </div>
              ) : isError ? (
                <div>
                  <h2 className="prime-head p-0 text-center">
                    Failed to load statistics from <em>{reviewItem}</em>. Please try after sometime.
                  </h2>
                </div>
              ) : (
                <div className="app-l-notes-wrapper">
                  <div className="app-l-notes-wrapper_header">
                    <div className="notes">{__pageConfig.title}</div>
                    <div className="notes_text">
                      {dataArray?.length ? (
                        <>
                          <span className="menuWrap__menuIndi">{dataArray?.length}</span>Action(s)
                          Pending
                        </>
                      ) : (
                        <>No Action Needed</>
                      )}
                    </div>
                    <div className="app-l-advanced-filters -advnc-user-filter">
                      <UserSelect
                        dependencies={{
                          query: { roles: [ROLES.TUTOR, ROLES.SUBJECT_EXPERT] },
                        }}
                        handleChange={(data) => {
                          if (data?._id) setUserObj(data);
                        }}
                        values={userObj}
                        isMulti={false}
                        hideLabel={true}
                        classNamePrefix={`-advnc-user-filter-select`}
                      />
                      <button
                        type="button"
                        onClick={() => {
                          setMoreFilters({ isOpen: true });
                        }}
                      >
                        Advanced Filters
                      </button>
                    </div>
                  </div>
                  <div className="app-l-notes-wrapper_body">
                    {dataArray?.length > 0 ? (
                      dataArray?.map((item) => {
                        return <ReviewItems key={item._id} {...item} reviewItem={reviewItem} />;
                      })
                    ) : (
                      <Box
                        sx={{
                          padding: '12px 32px 0',
                          width: '100%',
                        }}
                        fullWidth
                      >
                        <h1 className="text-center">No records found</h1>
                      </Box>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const __config = {
  notes: {
    title: 'Notes',
  },
  geek_corner: {
    title: 'Geek corner',
  },
  stories: {
    title: 'Stories',
  },
  videos: {
    title: 'Videos',
  },
  question_bank: {
    title: 'Question bank',
  },
  ncert_solutions: {
    title: 'NCERT',
  },
  past_papers: {
    title: 'Past papers',
  },
  mock_test: {
    title: 'Mock test',
  },
  previous_year: {
    title: 'Previous year',
  },
  mindMaps: {
    title: 'Mindmap',
  },
};

function ReviewItems(props) {
  const { authState } = React.useContext(AuthContext);
  const { privateFetch } = React.useContext(FetchContext);
  const token = authState?.token;
  const __isPerformTab = ['mock_test', 'previous_year'].includes(props.quizCategory);
  const __quizTab = __isPerformTab ? 'perform' : 'assess';

  const searchParams = new URLSearchParams({ lessonType: props.reviewItem });
  if (props.subtopic?._id) searchParams.append('subtopic', props.subtopic._id);

  const isV2 = process.env.REACT_APP_WETTING_VERSION === 'v2';

  const internalLink = `/classes/${props.class?._id}/courses/${props.course?._id}/chapters/${
    props.chapter?._id
  }/topics/${props.topic?._id}/contentPreview?${searchParams.toString()}`;
  const externalLink = `${process.env.REACT_APP_ADD_VIEWCOMMENTS_BASE_URL}?class=${
    props.class?._id
  }&course=${props.course?._id}&chapter=${props.chapter?._id}&topic=${
    props.topic?._id
  }&token=${token}&${searchParams.toString()}`;

  let linkVal = props.quiz
    ? `/classes/${props.class?._id}/courses/${props.course?._id}/${__quizTab}?quiz=${props.quiz?._id}&open=quiz&utm_source=review-tiles&currentTab=${props.quizCategory}`
    : isV2
    ? externalLink
    : internalLink;

  return (
    <>
      <div className="app-l-notes-wrapper_body--items">
        <div>
          <a href={linkVal} target="_blank" rel="noopener noreferrer" className="itemReviewLink">
            {__isPerformTab ? (
              <span>
                <>
                  {props.quizCategory === 'mock_test' && (
                    <>
                      Mock test <strong>{props.quiz?.name}</strong> from Course{' '}
                      <strong>{props.courseName}</strong> is available for review.
                    </>
                  )}
                  {props.quizCategory === 'previous_year' && (
                    <>
                      Previous year quiz <strong>{props.quiz?.name}</strong> from Course{' '}
                      <strong>{props.courseName}</strong> is available for review.
                    </>
                  )}
                </>
              </span>
            ) : (
              <span>
                <b>Vetting:</b> Review available in <strong>{props.courseName}</strong>{' '}
                {props.chapter?.name ? (
                  <>
                    on the chapter <strong>{props.chapter?.name}</strong>
                  </>
                ) : null}{' '}
                {props.topic?.name ? (
                  <>
                    under topic <strong>{props.topic?.name}</strong>
                  </>
                ) : null}{' '}
                {props.subtopic?.name ? (
                  <>
                    and under subtopic <strong>{props.subtopic?.name}</strong>
                  </>
                ) : null}{' '}
              </span>
            )}
          </a>
          {!props.quiz && (
            <div className="mt-2">
              <Link
                to={`/classes/${props.class?._id}/courses/${props.course?._id}/chapters/${props.chapter?._id}/topics/${props.topic?._id}?open=note`}
                className="btn btn-sm btn-outline-primary"
                style={{ fontSize: '12px' }}
              >
                Go to Status / Save Page
              </Link>
            </div>
          )}
          <div className="app-l-card-block">
            {props.class?.name && <div className="as-level">{props.class?.name}</div>}
            <div className="AQA">{props.courseName}</div>
            {/* <div className="tag"></div> */}

            <div className="d-flex align-items-center my-4 ml-auto">
              <Typography variant="h6" className="mx-2">
                All Issues: {props.totalComments || 0}
              </Typography>
              <Typography variant="h6" className="mx-2">
                Resolved Issues: {props.resolvedComment || 0}
              </Typography>
              <Typography variant="h6" className="mx-2">
                Unsolved Issues: {props.unResolvedComment || 0}
              </Typography>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center my-4">
            <Typography variant="h5" className="mx-2 __c_main">
              Maintainer : {props.contentMaintainedBy?.name || 'na'}
            </Typography>
            <Typography variant="h5" className="mx-2">
              Teacher :{' '}
              {props.assignedTutorForReview?.name ||
                props.quiz?.assignedTutorForReview?.name ||
                'na'}
            </Typography>
            <Typography variant="h5" className="mx-2 __c_own">
              Author : {props.contentOwner?.name || 'na'}
            </Typography>
            <Typography variant="h5" className="mx-2">
              QC : na
            </Typography>
          </div>
        </div>
        <div className="time">{props.updatedAt || props.date}</div>
      </div>
    </>
  );
}

export default IndividualReviewItem;
